module.exports = "<div ng-if=\"myData.length\">\n  <table class=\"{{$root.styles.tables.classic}}\">\n    <thead>\n      <tr>\n        <th>\n          <span ng-bind-html=\"'Numéro'\"></span>\n        </th>\n        <th ng-bind-html=\"'Ordre'\"></th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"item in myData\">\n        <td>\n          <span ng-bind-html=\"item | field\"></span>\n        </td>\n        <td ng-bind-html=\"$index + 1\"></td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/global/directives/tables/mySelectTable.html
// module id = 1196
// module chunks = 0